import { createContext } from "react";

export const DownloadContext = createContext();
